/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tiny_Quick_Penguin_BorrowInputs */

const fr_tiny_quick_penguin_borrow = /** @type {(inputs: Tiny_Quick_Penguin_BorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecte-toi`)
};

/**

* @param {Tiny_Quick_Penguin_BorrowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tiny_quick_penguin_borrow = /** @type {((inputs?: Tiny_Quick_Penguin_BorrowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tiny_Quick_Penguin_BorrowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tiny_quick_penguin_borrow(inputs)
});